export * from './People1CheckIcon';
export * from './People1CheckIcon16Light';
export * from './People1CheckIcon16Regular';
export * from './People1CheckIcon16Solid';
export * from './People1CheckIcon20Light';
export * from './People1CheckIcon20Regular';
export * from './People1CheckIcon20Solid';
export * from './People1CheckIcon24Regular';
export * from './People1CheckIcon24Solid';
export * from './People1CheckIcon32Regular';
export * from './People1CheckIcon64Regular';
